import { Label as f, Input as g } from "../../InputLabel/InputLabel.js";
import { classes as o } from "../../classes/classes.js";
import '../../assets/CheckInput.css';const h = "op_label_UmPs7", p = {
  label: h
};
function C(m) {
  let {
    settings: l,
    setSettings: s,
    settingToChange: t,
    index: c,
    id: i,
    inputAttributes: e = {},
    labelAttributes: a,
    label: r
  } = m;
  function d() {
    let n = [...l];
    n[c][t] = !l[c][t], s !== void 0 && s(n);
  }
  return /* @__PURE__ */ React.createElement(f, { ...a, className: o(p.label, a == null ? void 0 : a.className) }, /* @__PURE__ */ React.createElement(
    g,
    {
      type: "checkbox",
      name: i,
      defaultChecked: l[c][t],
      onClick: d,
      ...e,
      className: o(e == null ? void 0 : e.className)
    }
  ), r);
}
export {
  C as CheckInput
};
